<template>
    <AccountLayout :loading="0" :isError=false>
        <div>
            <v-container id="condition-box">
                <v-row  class="d-flex justify-center">
                    <v-col
                        class="pl-0 pr-0"
                        cols="12"
                        sm="auto"
                        md="auto"
                        style="display: flex; z-index: 1;"
                    >
                        <v-card
                            max-width="800"
                            style="border-radius: 30px 30px 30px 30px;"
                            elevation="0"
                        >
                            <v-card-text>
                                <v-form
                                    ref="form"
                                    lazy-validation
                                >
                                    <v-row class="mx-6">
                                        <v-col cols="12" sm="12" md="12" class="pb-0">
                                            <div
                                                class="mt-7 prompt-title-500"
                                                style="
                                                    color: #255d98;
                                                    font-weight: 400;
                                                    text-align: left;
                                                "
                                            >
                                                {{$t('message.conditionTermPage.header.h1')}}
                                            </div>
                                            <v-divider
                                                class="mt-3"
                                                style="
                                                    border: 2px solid #ff9800;
                                                    margin:14px 0px;
                                                "
                                            ></v-divider>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            sm="12"
                                            md="12"
                                            class="sarabun-18 pt-0"
                                        >
                                            {{$t('message.conditionTermPage.detail.h1')}}
                                            <div
                                                class="prompt-16 mt-5"
                                                style="
                                                    font-weight: 400;
                                                    text-align: left;
                                                "
                                            >
                                                {{$t('message.conditionTermPage.title.t1')}}
                                            </div>
                                            <v-divider class="my-3"></v-divider>
                                            {{$t('message.conditionTermPage.subtitle.t1.s1')}}

                                            <!-- Use v-html to convert text to html -->
                                            <div class="mt-3" v-html="convertTextToHtml($t('message.conditionTermPage.detail.t1.s1'))"></div>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <div id="orange-tab"></div>
        </div>
    </AccountLayout>
</template>

<script>
import AccountLayout from "@/components/common/AccountLayout";

export default {
    name: "ConditionComp",
    components: { AccountLayout },
    data: () => ({}),
    methods: {
        // Use this to convert i18n content that contain html tag to html format
        convertTextToHtml(content){
            var str=content;
            return str;
        }
    },
    isError:false
};
</script>
